/*
 * ============================
 * File: main.js
 * Project: Octavia-Admin
 * File Created: Thursday, 9th April 2020 2:11:05 am
 * Author:UILIB
 * AuthorUrl:https://ui-lib.com/
 * -----
 * Last Modified: Tuesday, 14th April 2020 7:17:10 pm
 * Modified By: naime hossain (naime.hossain93@gmail.com)
 * -----
 * Copyright 2020 - 2021 UILIB, UILIB
 * ============================
 */

import Vue from "vue";
import CircularCountDownTimer from 'vue-circular-count-down-timer';
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import * as Sentry from "@sentry/vue";

import vuetify from "./plugins/vuetify";
import "./plugins";

import octaviaKit from "@/plugins/octavia.kit";

// import VueApexCharts from 'vue-apexcharts';
// mock
import "./fake-db/index.js";

import kuid from "kuid";
// Vue.component('apexchart', VueApexCharts);

Vue.use(octaviaKit);
Vue.use(CircularCountDownTimer);
Vue.config.productionTip = false;
// if (process.env.NODE_ENV === "development") {
//   makeServer();
// }

// SENTRY
// Sentry.init({
//   Vue,
//   dsn: "https://ef176e05c576fbd29756cc2c70674f8d@o4507325967630336.ingest.us.sentry.io/4507325973135360",
//   integrations: [],
// });
// /SENTRY

if (!localStorage.getItem("person")) {
  window.person = {
    id: kuid(),
  };
  localStorage.setItem("person", JSON.stringify(window.person));
} else {
  window.person = JSON.parse(localStorage.getItem("person"));
}

new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
